/**
 * Требования к паролю
 */
export class PasswordRequirements {
  /**
   * требование к удовлетворительному паролю
   */
  public SatisfactoryPassword: string = "";

  /**
   * требование к стойкому паролю
   */
  public StrongPassword: string = "";

  /**
   * текстовое описание требований к паролю
   */
  public TextualDescriptionPassword: string = "";

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.SatisfactoryPassword = src.SatisfactoryPassword ?? "";
      this.StrongPassword = src.StrongPassword ?? "";
      this.TextualDescriptionPassword = (
        src.TextualDescriptionPassword ?? ""
      ).replace(/rn/g, "<br>");
    }
  }

  isEmpty() {
    return this.SatisfactoryPassword === "" && this.StrongPassword  === "" && this.TextualDescriptionPassword  === ""
  }
}
